import http from '@/utils/http'
import httpApi from '@/apis/httpApi'

// 获取城市列表
export const getCity=({
    grep,
    pfid
})=>{
    return http.usualPost({
        url:httpApi.module.getCity,
        data:{
            grep,
            pfid:pfid===undefined?0:pfid
        }
    })
}